import { func, node, number, oneOfType, shape, string } from 'prop-types';
import React, { Component } from 'react';
import { Button, Input, Popover } from 'reactstrap';

import { COLORS } from '../../utils/constants';

export default class ButtonWithMessagePopover extends Component {
  state = {
    isOpen: false,
    disabled: false,
    message: '',
  };

  handleOnClick = async () => {
    const { onSubmit } = this.props;
    const { message } = this.state;

    this.setState({ disabled: true });

    try {
      await onSubmit(message);
      this.toggle();
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }

    this.setState({ disabled: false });
  };

  setMessage = e => {
    this.setState({ message: e.target.value });
  };

  toggle = () => {
    this.setState(state => ({
      isOpen: !state.isOpen,
    }));
  };

  render() {
    const { id, onSubmit, children, submitProps, inputProps, ...rest } =
      this.props;
    const { isOpen, message, disabled } = this.state;
    return (
      <>
        <Button id={`message-popover-${id}`} disabled={disabled} {...rest}>
          {children}
        </Button>
        <Popover
          target={`message-popover-${id}`}
          trigger="legacy"
          toggle={this.toggle}
          placement="bottom"
          isOpen={isOpen}
        >
          <div style={{ width: 270 }} className="small p-2 text-right">
            <Input
              {...inputProps}
              type="textarea"
              bsSize="sm"
              className="mb-2"
              value={message}
              onChange={this.setMessage}
            />
            <Button
              size="sm"
              color={COLORS.SECONDARY}
              outline
              onClick={this.toggle}
            >
              Cancel
            </Button>
            <Button
              {...submitProps}
              disabled={!message.length}
              size="sm"
              className="ml-2"
              onClick={this.handleOnClick}
            />
          </div>
        </Popover>
      </>
    );
  }
}

ButtonWithMessagePopover.propTypes = {
  id: oneOfType([number, string]).isRequired,
  onSubmit: func.isRequired,
  children: node.isRequired,
  submitProps: shape(Button.propTypes),
  inputProps: shape(Input.propTypes),
};

ButtonWithMessagePopover.defaultProps = {
  inputProps: {},
  submitProps: {
    color: COLORS.PRIMARY,
    children: 'Submit',
  },
};
